import { FC } from 'react';
import cx from 'classnames/bind';

import type { IGame } from '@/types/game';
import { getBuyer } from '@/utils/getBuyer';

import styles from './Buyer.module.scss';

interface BuyerProps {
  idGame: number;
  scenarios: IGame[];
}

const cn = cx.bind(styles);

const Buyer: FC<BuyerProps> = ({ idGame, scenarios }) => {
  const src = getBuyer(scenarios, idGame);

  return (
    <div className={cn('imgWrapper')}>
      <img className={cn('img')} src={src} alt="Покупатель" />
    </div>
  );
};

export default Buyer;
